import React from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { loadCss } from "helpers/function";
import { verifyPermission } from "helpers/permission";
import { ERROR_401 } from "config/errorPage";
import LoadingTable from "views/components/LoadingTable";
import HeaderTablePage from "views/components/HeaderTablePage";
import InfirmationTable from "views/components/InfirmationTable";
import Pagination from "views/components/Pagination";
import { useReportConfigData } from "hooks/configs/auto-report/useReportConfigData";
import { usePagination } from "hooks/configs/auto-report/usePagination";
import { useSearch } from "hooks/configs/auto-report/useSearch";
import { useDeleteReport } from "hooks/configs/auto-report/useDeleteReport";
import SearchInput from "components/configs/auto-report/SearchInput";
import ReportTable from "components/configs/auto-report/ReportTable";
import DataTableInfo from "components/configs/auto-report/DataTableInfo";

loadCss("/assets/plugins/custom/datatables/datatables.bundle.css");

const ConfigRapportAuto = (props) => {
  const { t, ready } = useTranslation();

  React.useEffect(() => {
    document.title =
      "Satis rapport - " +
      (ready ? t("Paramètre configuration rapport automatique") : "");
  }, [ready, t]);

  const hasPermission = React.useMemo(() => {
    return verifyPermission(
      props.userPermissions,
      "list-config-reporting-claim-my-institution"
    );
  }, [props.userPermissions]);

  React.useEffect(() => {
    if (!hasPermission) {
      window.location.href = ERROR_401;
    }
  }, [hasPermission]);

  const {
    loading,
    rapportAuto,
    setRapportAuto,
    endPoint,
  } = useReportConfigData(props.plan, props.userPermissions);

  const { searchElement } = useSearch(rapportAuto);

  const {
    showList,
    numberPerPage,
    activeNumberPage,
    numberPage,
    pages,
    onChangeNumberPerPage,
    onClickPage,
    onClickNextPage,
    onClickPreviousPage,
    searchWithPagination,
  } = usePagination(rapportAuto, searchElement);

  const { deleteReport } = useDeleteReport(
    rapportAuto,
    setRapportAuto,
    endPoint,
    numberPerPage,
    activeNumberPage,
    showList
  );

  const handleSearch = React.useCallback(
    (searchValue) => {
      searchWithPagination(searchValue);
    },
    [searchWithPagination]
  );

  if (!ready || !hasPermission) return null;

  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader kt-grid__item" id="kt_subheader">
        <div className="kt-container kt-container--fluid">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">{t("Paramètres")}</h3>
            <span className="kt-subheader__separator kt-hidden" />
            <div className="kt-subheader__breadcrumbs">
              <a href="#icone" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter" />
              </a>
              <span className="kt-subheader__breadcrumbs-separator" />
              <a
                href="#button"
                onClick={(e) => e.preventDefault()}
                className="kt-subheader__breadcrumbs-link"
              >
                {t("Rapport automatique")}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
        <InfirmationTable information={t("Liste des rapports automatiques")} />

        <div className="kt-portlet">
          <HeaderTablePage
            addPermission="store-config-reporting-claim-my-institution"
            title={t("Rapport Automatique")}
            addText={verifyPermission(props.userPermissions, "store-config-reporting-claim-my-institution") && t("Ajouter une configuration")}
            addLink={verifyPermission(props.userPermissions, "store-config-reporting-claim-my-institution") && "/settings/rapport/add"}
          />

          {loading ? (
            <LoadingTable />
          ) : (
            <div className="kt-portlet__body">
              <div
                id="kt_table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4"
              >
                <div className="row">
                  <div className="col-sm-6 text-left">
                    <SearchInput onSearch={handleSearch} t={t} />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12">
                    <ReportTable
                      rapportAuto={rapportAuto}
                      showList={showList}
                      plan={props.plan}
                      userPermissions={props.userPermissions}
                      onDelete={deleteReport}
                      t={t}
                    />
                  </div>
                </div>

                {/* Pagination */}
                <div className="row">
                  <div className="col-sm-12 col-md-5">
                    <DataTableInfo
                      numberPerPage={numberPerPage}
                      totalItems={rapportAuto.length}
                      t={t}
                    />
                  </div>
                  {showList.length > 0 && (
                    <div className="col-sm-12 col-md-7 dataTables_pager">
                      <Pagination
                        numberPerPage={numberPerPage}
                        onChangeNumberPerPage={onChangeNumberPerPage}
                        activeNumberPage={activeNumberPage}
                        onClickPreviousPage={onClickPreviousPage}
                        pages={pages}
                        onClickPage={onClickPage}
                        numberPage={numberPage}
                        onClickNextPage={onClickNextPage}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userPermissions: state.user.user.permissions,
  plan: state.plan.plan,
});

export default connect(mapStateToProps)(ConfigRapportAuto);
